import { Component, ViewChild, TemplateRef } from '@angular/core';
import { UserService } from '../../../services/user.service';
import { Revisor } from '../../../models/revisor.model';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { RutValidator } from 'ng2-rut';
import { FormService } from 'src/app/services/form.service';
import { MatDialog } from '@angular/material';
import { NgxSpinnerService } from 'ngx-spinner';
import { startWith, map } from 'rxjs/operators';
declare var jQuery: any;
declare var $: any;
@Component({
  selector: 'app-revisor-proyecto',
  templateUrl: './revisor-proyecto.component.html',
  styleUrls: ['./revisor-proyecto.component.css'],
  providers: [UserService, FormService]
})
export class RevisorProyectoComponent {
  @ViewChild('confirmarReemplazo') confirmarReemplazoTemplate: TemplateRef<any>;
  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;

  public rut_ind;
  public invalidRut: Boolean;
  public revisor: Revisor;
  public rows = [];
  public actualRow;
  public matcher = new FormService();

  public filteredOptions;
  public nombreComuna = new FormControl('', [Validators.required]);
  options = []
  public selectedRev: number = null;
  public mail_rev
  regexp = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);


  constructor(private fb: FormBuilder, private _userService: UserService,
    private rutValidator: RutValidator, private dialog: MatDialog, private spinner: NgxSpinnerService) {

    this.rut_ind = this.fb.group({
      rut: ['', [Validators.required, this.rutValidator]]
    })

    this.mail_rev = this.fb.group({
      mail: ['', [Validators.pattern(this.regexp), Validators.required, Validators.maxLength(50)]]
    })

    if (!JSON.parse(localStorage.getItem("revisorCalculo"))) {
      localStorage.setItem("revisorCalculo", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("revisorCalculo"));
    }
    this.invalidRut = true;

    this.revisor = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', recordId: '' };
  }

  ngOnInit() {

  }


  ngAfterContentInit() {
    this.getComunas()
    this.filteredOptions = this.nombreComuna.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.options.filter(option => option.toLowerCase().includes(filterValue));
  }

  get_revisor(rut) {
    this.spinner.show();
    this.cleanData();
    this._userService.getRevisor(rut).subscribe(
      response => {
        if (response.message) {
          this.revisor.rut = rut ? rut : '';
          this.spinner.hide();
          this.dialog.open(this.openModal);
        } else {
          this.revisor.rut = response.rut ? response.rut : '';
          this.revisor.nombre = response.nombre ? response.nombre : '';
          this.revisor.apellido_mat = response.apellido_mat ? response.apellido_mat : '';
          this.revisor.apellido_pat = response.apellido_pat ? response.apellido_pat : '';
          this.revisor.direccion = response.direccion ? response.direccion : '';
          this.revisor.direccion_num = response.direccion_num ? response.direccion_num : '';
          this.revisor.direccion_complemento = response.direccion_complemento ? response.direccion_complemento : '';
          this.revisor.direccion_completa = response.direccion_completa ? response.direccion_completa : '';
          this.revisor.comuna = response.comuna ? response.comuna : '';
          this.revisor.fono = response.fono ? response.fono : '';
          this.revisor.fax = response.fax ? response.fax : '';
          this.revisor.mail = response.mail ? response.mail : '';
          this.revisor.patente = response.patente ? response.patente : '';
          this.revisor.registro = response.registro ? response.registro : '';
          this.revisor.categoria = response.categoria ? response.categoria : '';
          this.revisor.recordId = response.recordId ? response.recordId : '';
          this.spinner.hide();
          this.dialog.open(this.openModal);
        }

      },
      error => {
        console.log(error)
        this.spinner.hide();
      }
    )
  }

  cleanData() {
    this.revisor = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' };
    this.rut_ind.reset()
  }


  update_revisor(rut, id) {
    this.get_revisor(rut);
    this.selectedRev = id;
  }


  saverevisor() {
    this.spinner.show();
    //elimina la fila si escriben un rut que ya esté ingresado
    for (let x = 0; x < this.rows.length; x++) {
      if (this.revisor.rut == this.rows[x].rut) {
        this.delete_revisor(x);
      }
    }

    //elimina fila cuando la editan
    /*if (this.selectedRev != null) {
        this.delete_revisor(this.selectedRev);
        this.selectedRev = null;
    }*/


    this._userService.saveRevisor(this.revisor).subscribe(
      response => {
        this.spinner.hide();

        if (response.update || response.save) {
          $("#ind_modal").modal("hide");
          const stored = localStorage.getItem("revisorCalculo");
          this.rows = stored ? JSON.parse(stored) : [];

          if (this.rows.length > 0) {
            this.dialog.closeAll()
            this.newPropietario()
           /*  const dialogRef = this.dialog.open(this.confirmarReemplazoTemplate, {
              width: '400px',
              disableClose: true,
              data: {}
            });

            dialogRef.afterClosed().subscribe(result => {
              if (result === true) {
                console.log("se quiere reemplazar");
              }
            }); */
          } else {
            this.newPropietario()
          }

        }
      },
      error => {
        this.spinner.hide();

        console.log(error)
      }
    )
  }

  newPropietario() {
   
    this.rows = this.rows.concat({
      rut: this.revisor.rut,
      nombre: this.revisor.nombre,
      apellido_mat: this.revisor.apellido_mat,
      apellido_pat: this.revisor.apellido_pat,
      direccion: this.revisor.direccion,
      direccion_num: this.revisor.direccion_num,
      direccion_complemento: this.revisor.direccion_complemento,
      direccion_completa: this.revisor.direccion_completa,
      comuna: this.revisor.comuna,
      fono: this.revisor.fono,
      fax: this.revisor.fax,
      mail: this.revisor.mail,
      patente: this.revisor.patente,
      registro: this.revisor.registro,
      categoria: this.revisor.categoria
    });

    // Resetear campos y cerrar el diálogo
    localStorage.setItem("revisorCalculo", JSON.stringify(this.rows));
    this.revisor = { rut: '', nombre: '', apellido_mat: '', apellido_pat: '', direccion: '', direccion_num: '', direccion_complemento: '', direccion_completa: '', comuna: '', fono: '', fax: '', mail: '', patente: '', registro: '', categoria: '', recordId: '' };
    this.rut_ind.reset();
    this.dialog.closeAll();
  }
  delete_revisor(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("revisorCalculo", JSON.stringify(this.rows));
        this.rows = JSON.parse(localStorage.getItem('revisorCalculo'));
      }
    }
  }

  getComunas() {

    if (JSON.parse(localStorage.getItem("comunas"))) {
      if (JSON.parse(localStorage.getItem("comunas")).length > 0) {
        this.options = JSON.parse(localStorage.getItem('comunas'));

      } else {
        this.options = []
      }
    }

    this.filteredOptions = this.nombreComuna.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

  }
}
